import sha1 from "js-sha1";
const state = {
  build: sha1(process.env.VUE_APP_BUILD),
  initializedAt: Date.now(),
  showHeader: true,
  forceLandscape: false,
  isNavbarShowing: true
};
const mutations = {
  // SET_BUILD(state, build) {
  //   state.build = build;
  //   state.buildUpdated = Date.now();
  // }
  SET_IS_NAVBAR_SHOWING(state, value) {
    state.isNavbarShowing = value;
  },

  SET_SHOW_HEADER(state, value) {
    state.showHeader = value;
  },
  SET_FORCE_LANDSCAPE(state, value) {
    state.forceLandscape = value;
  }
};
const actions = {
  // updateBuild(context, build) {
  //   context.commit("SET_BUILD", build);
  // }
  setShowHeader(context, value) {
    context.commit("SET_SHOW_HEADER", value);
    context.commit("SET_IS_NAVBAR_SHOWING", value);
  },
  setIsNavbarShowing(context, value) {
    context.commit("SET_IS_NAVBAR_SHOWING", value);
  },
  setForceLandscape(context, value) {
    context.commit("SET_FORCE_LANDSCAPE", value);
  }
};
const getters = {
  ageInSeconds: state => (state.initializedAt - Date.now()) * 1000,
  getBuild: state => state.build,
  getShowHeader: state => state.showHeader,
  getIsNavbarShowing: state => state.isNavbarShowing,
  getForceLandscape: state => state.forceLandscape
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
